import React from 'react';
import { makeStyles } from '@material-ui/styles';
import { Avatar, Grid, Link, Typography } from '@material-ui/core';
import RichEditorReadOnly from '../../components/RichEditorReadOnly/RichEditorReadOnly';

const useStyles = makeStyles((theme) => ({
  root: {
    padding: '17px'
  },
  contentDescription: {
    color: theme.palette.text.primary,
    marginBottom: 20
  },
  logo: {
    width: 150,
    height: 150,
    margin: 14
  },
  nameCompany: {
    color: theme.palette.text.primary,
    textAlign: 'center',
    marginBottom: 20
  },
  extraInfo: {
    color: theme.palette.text.primary,
    marginTop: 5,
    marginBottom: 5
  },
  iconsHelper: {
    marginBottom: -3
  },
  companyLink: {
    color: theme.palette.text.primary,
    textDecoration: 'none'
  }
}));

const CompanyView = ({ company, logoUrl }) => {
  const classes = useStyles();
  const companyName = company?.name ?? null;
  const locationCompany = company?.location ?? '';
  const webPageCompany = company?.siteURL ?? '';
  const detailsCompany = company?.detail ?? '';
  const getRenderEditor = (companyDetails) => (
    <RichEditorReadOnly content={companyDetails ? companyDetails : null} />
  );
  return (
    <div className={classes.root}>
      <Grid
        alignItems="center"
        container
        direction="column"
        justifyContent="center">
        {logoUrl && (
          <Grid item>
            <Avatar
              variant="circular"
              data-test="logo-img-company-view"
              className={classes.logo}
              src={logoUrl}
            />
          </Grid>
        )}
        {companyName && (
          <Grid item>
            <Typography className={classes.nameCompany} variant="h1">
              {companyName}
            </Typography>
          </Grid>
        )}
        {detailsCompany && (
          <Grid item className={classes.contentDescription}>
            {getRenderEditor(detailsCompany)}
          </Grid>
        )}
        {locationCompany && (
          <Grid
            item
            justifyContent="flex-start"
            container
            direction="row"
            spacing={1}>
            <Typography className={classes.extraInfo} variant="body1">
              {'📍 '}
              {locationCompany}
            </Typography>
          </Grid>
        )}
        {webPageCompany && (
          <Grid
            item
            justifyContent="flex-start"
            container
            direction="row"
            spacing={1}>
            <Typography className={classes.extraInfo} variant="body1">
              {'🔗 '}
              <Link
                href={webPageCompany}
                target="_blank"
                className={classes.companyLink}
                rel="noopener noreferrer">
                Website
              </Link>
            </Typography>
          </Grid>
        )}
      </Grid>
    </div>
  );
};

export default CompanyView;
